import React, { useState } from 'react';
import { Fade, Stack } from '@mui/material';

export function withButton<P>(WrappedComponent: React.ComponentType<P>, ButtonComponent: React.ComponentType<any>) {
  return (props: P) => {
    const [hover, setHover] = useState(false);

    return (
      <Stack gap={1} direction={'row'} alignItems={'flex-start'}
             position="relative"
             onMouseEnter={() => setHover(true)}
             onMouseLeave={() => setHover(false)}>
        <WrappedComponent {...props} />
        <Fade in={hover}>
          <ButtonComponent {...props} onClick={() => setHover(false)} />
        </Fade>
      </Stack>
    );
  }
}
